
import { oz } from '@weft/utils';
import { ApiDateSchema } from '../../primitives';
import { ObjectIdSchema } from '../../primitives/object-id-schema';
import { PeriodSchema } from '../../primitives/period-schema';
import { withNullAsOptional } from '../../utils/literal-transforms';

export const NewMeasurementSchema = oz.object({
  accountId: ObjectIdSchema,
  period: PeriodSchema,
  meterId: ObjectIdSchema,
  customerId: ObjectIdSchema,
  value: oz.number().nonnegative(),
  price: withNullAsOptional(oz.number()),
  measurementPriceId: withNullAsOptional(ObjectIdSchema),
  latestEventUpdatedAt: ApiDateSchema.optional(),
  instanceKey: oz.string().optional(),
});

export type NewMeasurement = oz.infer<typeof NewMeasurementSchema>;